import React__default from 'react';
import { useProductDetailContext } from '../Context/ProductDetailContext.js';

const useDeliveryIntervalOptions = ({ deliveryInterval  })=>{
    const { deliveryIntervalOptions  } = useProductDetailContext();
    const selectedInterval = React__default.useMemo(()=>{
        if (!!deliveryInterval && !!deliveryIntervalOptions) {
            const options = Object.entries(deliveryIntervalOptions);
            const fallbackOption = options[0];
            const selectedOption = options.find(([_, value])=>value === deliveryInterval
            ) || fallbackOption;
            return {
                value: selectedOption[0]
            };
        }
        return undefined;
    }, [
        deliveryInterval,
        deliveryIntervalOptions
    ]);
    return {
        selectedInterval,
        deliveryIntervalOptions
    };
};

export { useDeliveryIntervalOptions };
//# sourceMappingURL=use-delivery-interval-options.js.map
